var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnersChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 12,
    r: 3,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners3DotsBounce0",
    attributeName: "cy",
    begin: "0;svgSpinners3DotsBounce1.end+0.25s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".33,.66,.66,1;.33,0,.66,.33",
    values: "12;6;12"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    begin: "svgSpinners3DotsBounce0.begin+0.1s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".33,.66,.66,1;.33,0,.66,.33",
    values: "12;6;12"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 12,
    r: 3,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners3DotsBounce1",
    attributeName: "cy",
    begin: "svgSpinners3DotsBounce0.begin+0.2s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".33,.66,.66,1;.33,0,.66,.33",
    values: "12;6;12"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnersChat);
export default __webpack_public_path__ + "static/media/spinners_chat.c3d973b25a65664c49f44fc21293ea01.svg";
export { ForwardRef as ReactComponent };